// react
import React, { useEffect, useState } from 'react';

// third-party
import classNames from 'classnames';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

// application
import AsyncAction from '../shared/AsyncAction';
import Currency from '../shared/Currency';
import PageHeader from '../shared/PageHeader';
import Rating from '../shared/Rating';
import { cartAddItem } from '../../store/cart';
import { Cross12Svg } from '../../svg';
import { url } from '../../services/utils';
import { wishlistRemoveItem } from '../../store/wishlist';
import apiServices from '../../api/apiservices';
import constant from '../../services/constant'

import InputNumber from '../shared/InputNumber';

// data stubs
import theme from '../../data/theme';

function ShopPageWishlist(props) {
    const { wishlist, cartAddItem, wishlistRemoveItem } = props;
    const breadcrumb = [
        { title: 'Home', url: '' },
        { title: 'Wishlist', url: '' },
    ];
    // const [token, setToken] = useState(localStorage.getItem(constant.CONSTANTS.USER_TOKEN));
    // const [wishlistContent, setWishlistContent] = useState([]);

    let content;

    useEffect(() => {
        console.log('mounted');
        console.log(wishlist)
        return () => console.log('unmounting...');
    }, [])


    if (wishlist.length) {
        const itemsList = wishlist.map((item) => {
            let image;
            console.log(item)
            if (item.images.length > 0) {
                image = (
                    <div className="product-image">
                        <Link to={url.product(item)} className="product-image__body">
                            <img className="product-image__img" src={item.images[0]} alt="" />
                        </Link>
                    </div>
                );
            }

            const renderAddToCarButton = ({ run, loading, item }) => {
                console.log(loading)
                console.log(item)
                const classes = classNames('btn btn-primary btn-sm text-color-white', {
                    'btn-loading': loading,
                });
                // disabled={item.quantity == "0"}
                return <button type="button" disabled={item?.quantity == "0"} onClick={run} className={classes}>Add To Cart</button>;
            };

            const renderRemoveButton = ({ run, loading }) => {
                const classes = classNames('btn btn-light btn-sm btn-svg-icon', {
                    'btn-loading': loading,
                });
                return <button type="button" onClick={run} className={classes} aria-label="Remove"><Cross12Svg /></button>;
            };

            return (
                <tr key={item.id} className="wishlist__row">
                    <td className="wishlist__column wishlist__column--image">
                        {image}
                    </td>
                    <td className="wishlist__column wishlist__column--product">
                        <Link to={url.product(item)} className="wishlist__product-name">{item.name}</Link>
                        <div className="wishlist__product-rating">
                        </div>
                    </td>

                    {/* <td className="cart-table__column cart-table__column--product">
                        {item.selectedVariant?.size}
                    </td>

                    <td className="cart-table__column cart-table__column--product">
                        {item.selectedVariant?.color}
                    </td> */}

                    {/* <td className="cart-table__column cart-table__column--quantity" data-title="Quantity">
                        {item.selectedVariant.quantity}
                    </td> */}

                    {/* <td className="wishlist__column wishlist__column--stock">

                        {item.quantity == "0" ?
                            <span className="badge badge-danger">Out Of Stock</span>
                            :
                            <span className="badge badge-success">In Stock</span>
                        }

                    </td> */}

                    {/* HIDE PRICE */}
                    {/* <td className="wishlist__column wishlist__column--price"><Currency value={item.price} /></td> */}
                    <td className="wishlist__column wishlist__column--tocart">
                        <AsyncAction
                            action={() => cartAddItem(item)}
                            render={renderAddToCarButton}
                            item={item}
                        />
                    </td>
                    <td className="wishlist__column wishlist__column--remove">
                        <AsyncAction
                            action={() => wishlistRemoveItem(item.id)}
                            render={renderRemoveButton}
                        />
                    </td>
                </tr>
            );
        });

        content = (
            <div className="block">
                <div className="container">
                    <table className="wishlist">
                        <thead className="wishlist__head">
                            <tr className="wishlist__row">
                                <th className="wishlist__column wishlist__column--image">Image</th>
                                <th className="wishlist__column wishlist__column--product">Product</th>

                                {/* <th className="cart-table__column cart-table__column--product">Size</th>
                                <th className="cart-table__column cart-table__column--product">Color</th> */}
                                {/* <th className="cart-table__column cart-table__column--quantity">Quantity</th> */}

                                {/* <th className="wishlist__column wishlist__column--stock">Stock Status</th> */}
                                {/* HIDE PRICE */}
                                {/* <th className="wishlist__column wishlist__column--price">Price</th> */}
                                <th className="wishlist__column wishlist__column--tocart text-color-white" aria-label="Add to cart" />
                                <th className="wishlist__column wishlist__column--remove" aria-label="Remove" />
                            </tr>
                        </thead>
                        <tbody className="wishlist__body">
                            {itemsList}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    } else {
        content = (
            <div className="block block-empty">
                <div className="container">
                    <div className="block-empty__body">
                        <div className="block-empty__message">Your wish list is empty!</div>
                        <div className="block-empty__actions">
                            <Link to="/" className="btn btn-primary btn-sm text-color-white">Continue</Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <React.Fragment>
            <Helmet>
                <title>{`Wish List — ${theme.name}`}</title>
            </Helmet>

            <PageHeader header="Wishlist" breadcrumb={breadcrumb} />

            {content}
        </React.Fragment>
    );
}

const mapStateToProps = (state) => ({
    wishlist: state.wishlist,
});

const mapDispatchToProps = {
    cartAddItem,
    wishlistRemoveItem,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ShopPageWishlist);
